import { render, staticRenderFns } from "./OrderCheckWait.vue?vue&type=template&id=42adf003&"
import script from "./OrderCheckWait.vue?vue&type=script&lang=ts&"
export * from "./OrderCheckWait.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports